import { render, staticRenderFns } from "./tabBar.vue?vue&type=template&id=180ec4d0&scoped=true&"
import script from "./tabBar.js?vue&type=script&lang=js&"
export * from "./tabBar.js?vue&type=script&lang=js&"
import style0 from "./tabBar.less?vue&type=style&index=0&id=180ec4d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ec4d0",
  null
  
)

export default component.exports